import { render, staticRenderFns } from "./operationRemark.vue?vue&type=template&id=342b5b32&scoped=true"
import script from "./operationRemark.vue?vue&type=script&lang=js"
export * from "./operationRemark.vue?vue&type=script&lang=js"
import style0 from "./operationRemark.vue?vue&type=style&index=0&id=342b5b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342b5b32",
  null
  
)

export default component.exports